import { useQuery } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { getOptInFeatures } from '../Services/OptInFeatures.service';
import type { OptInFeatureListRequest } from '../Types/OptInFeatures.types';
import { MAX_LIST_LIMIT } from '@/Shared/constants/listLimits';

/**
 * Every opt-in feature, or a filtered set.
 *
 * Asks for the maximum by default, for the same reason as {@link useTours}: the BFF listing
 * defaults to 10 items and this screen groups the whole result by BU.
 */
export const useOptInFeatures = (params: OptInFeatureListRequest = {}) =>
  useQuery({
    queryKey: optInFeaturesQueryKeys.list(params),
    queryFn: () => getOptInFeatures({ limit: MAX_LIST_LIMIT, ...params }),
  });
